import { Operation } from "@insightfulscience/shared-utils/gqlClient/operation";
import { isExpectedGqlError } from "@insightfulscience/shared-utils/gqlClient/GqlError";
import * as Sentry from "@sentry/node";

import { isTokenValid } from "../../domain/token";
import REFRESH_ACCESS from "./refreshAccess.mutation.graphql";

const isUnauthorized = isExpectedGqlError(401);

const RecoveryService = ({
	storageService: { refreshToken, setTokens },
	authService,
	globalContext,
}) => ({
	shouldBeRecovered: err =>
		err instanceof Error && isUnauthorized(err) && isTokenValid(refreshToken.read()),

	recover: () => {
		let recoveringPromise = null;

		const signOut = async () => {
			await authService.signOut({ localOnly: true });
			return authService.toAuth({ redirectPath: globalContext.asPath }, {});
		};

		return (context, operation, gqlClient) => {
			recoveringPromise =
				recoveringPromise ||
				gqlClient
					.last(Operation(REFRESH_ACCESS, { refreshToken: refreshToken.read() }), context)
					.then(({ refreshAccessV2 }) => {
						if ("errorCode" in refreshAccessV2) return signOut(); // never resolves

						if ("bindSessionToken" in refreshAccessV2) {
							return authService.bindSession({
								bindSessionToken: refreshAccessV2.bindSessionToken,
								redirectPath: globalContext.asPath,
							}); // never resolves
						}

						setTokens(refreshAccessV2);

						// Reset the recovering promise only if we successfully recovered.
						recoveringPromise = null;

						return undefined;
					})
					.catch(error => {
						Sentry.captureException(error);
						return signOut(); // never resolves
					});

			return recoveringPromise;
		};
	},
});

export default RecoveryService;
